export default {
	state: {
		statusParticipacao: {}
	},
	getters: {
		"statusParticipacao": state => state.statusParticipacao
	},
	mutations: {
		setStatusParticipacao(state, payload) {
			state.statusParticipacao = payload
		}
	},
	actions: {
		atualizarStatusParticipacao({ commit }, payload) {
			commit('setStatusParticipacao', payload)
		}
	}
};